import { Clock } from 'lucide-react'
import { SectionCard } from '../../patterns/SectionCard'

function hm(seconds: number): string {
  const h = Math.floor(seconds / 3600), m = Math.round((seconds % 3600) / 60)
  return h ? `${h}h ${m}m` : `${m}m`
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function MyTimeCard({ time }: { time: any | null }) {
  if (!time || !time.days?.length) return null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const max = Math.max(1, ...time.days.map((d: any) => d.seconds))
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const total = time.days.reduce((s: number, d: any) => s + d.seconds, 0)
  return (
    <SectionCard icon={<Clock size={14} />} title="My time" subtitle={`${hm(total)} this week`} fill>
      <div className="flex items-end gap-1.5 h-16">
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        {time.days.map((d: any) => (
          <div key={d.date} className="flex-1 flex flex-col items-center gap-1" title={`${d.date}: ${hm(d.seconds)}`}>
            <div className="w-full rounded-sm bg-primary/70" style={{ height: `${Math.max(2, (d.seconds / max) * 56)}px` }} />
            <span className="text-[9px] text-muted-foreground">{new Date(d.date + 'T00:00:00Z').toLocaleDateString('en-US', { weekday: 'narrow', timeZone: 'UTC' })}</span>
          </div>
        ))}
      </div>
    </SectionCard>
  )
}
